var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col', 'form-personal'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名:",
      "prop": "name"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.name)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别:",
      "prop": "gender"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.genderText)
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "f-edit",
    model: {
      value: (_vm.ruleForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gender", $$v)
      },
      expression: "ruleForm.gender"
    }
  }, _vm._l((_vm.selectMap.WB_GENDER), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号:",
      "prop": "mobilePhone"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.mobilePhone)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20
    },
    model: {
      value: (_vm.ruleForm.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mobilePhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.mobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱:",
      "prop": "email"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.email)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简历来源:",
      "prop": "resumeSource"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', _vm.ruleForm.resumeSource))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择简历来源"
    },
    model: {
      value: (_vm.ruleForm.resumeSource),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "resumeSource", $$v)
      },
      expression: "ruleForm.resumeSource"
    }
  }, _vm._l((_vm.selectMap.WB_RESUME_SOURCE), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘信息来源:"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_SOURCE_FROM', _vm.ruleForm.sourceFrom))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择招聘信息来源"
    },
    model: {
      value: (_vm.ruleForm.sourceFrom),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sourceFrom", $$v)
      },
      expression: "ruleForm.sourceFrom"
    }
  }, _vm._l((_vm.selectMap.WB_SOURCE_FROM), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前所在地:",
      "prop": "residence"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.residence)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.residence),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "residence", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.residence"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应聘城市:",
      "prop": "expectCityId"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', _vm.ruleForm.expectCityId))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择应聘城市"
    },
    model: {
      value: (_vm.ruleForm.expectCityId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "expectCityId", $$v)
      },
      expression: "ruleForm.expectCityId"
    }
  }, _vm._l((_vm.selectMap.WB_POSITION_CITY), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作年限:",
      "prop": "workYears"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_WORK_YEARS', _vm.ruleForm.workYears))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择工作年限"
    },
    model: {
      value: (_vm.ruleForm.workYears),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "workYears", $$v)
      },
      expression: "ruleForm.workYears"
    }
  }, _vm._l((_vm.selectMap.WB_WORK_YEARS), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生日期:",
      "prop": "birthday"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.birthdayText)
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "f-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "editable": false,
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ruleForm.birthday),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "birthday", $$v)
      },
      expression: "ruleForm.birthday"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "籍贯:",
      "prop": "origin"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.origin)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 50,
      "placeholder": "户籍所在地，如：广东广州"
    },
    model: {
      value: (_vm.ruleForm.origin),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "origin", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.origin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证件类型:",
      "prop": "papersType"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_ID_CARD_TYPE', _vm.ruleForm.papersType))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择证件类型"
    },
    model: {
      value: (_vm.ruleForm.papersType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "papersType", $$v)
      },
      expression: "ruleForm.papersType"
    }
  }, _vm._l((_vm.selectMap.WB_ID_CARD_TYPE), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证件号:",
      "prop": "papersNumber"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.papersNumber)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请输入证件号码",
      "maxlength": 30
    },
    model: {
      value: (_vm.ruleForm.papersNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "papersNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.papersNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐人:",
      "prop": "recommender"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.recommenderText)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请输入内推码和姓名，如：GO0111张三",
      "maxlength": 30
    },
    model: {
      value: (_vm.ruleForm.recommender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "recommender", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.recommender"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "与推荐人关系:"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.relationship)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请输入与推荐人的关系",
      "maxlength": 30
    },
    model: {
      value: (_vm.ruleForm.relationship),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "relationship", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.relationship"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望薪资:",
      "prop": "expectSalary"
    }
  }, [_c('p', {
    staticClass: "f-view"
  }, [_vm._v(_vm._s(_vm.ruleForm.expectSalary))]), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "min": 0,
      "placeholder": "请输入期望薪资",
      "maxlength": 30,
      "type": "number"
    },
    model: {
      value: (_vm.ruleForm.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "expectSalary", _vm._n($$v))
      },
      expression: "ruleForm.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接受调剂:",
      "prop": "acceptRegulate"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_ACCEPT_REGULATE', _vm.ruleForm.acceptRegulate))
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "f-edit",
    model: {
      value: (_vm.ruleForm.acceptRegulate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "acceptRegulate", $$v)
      },
      expression: "ruleForm.acceptRegulate"
    }
  }, _vm._l((_vm.selectMap.WB_ACCEPT_REGULATE), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "游戏经验:",
      "prop": "gameExperience"
    }
  }, [_c('p', {
    staticClass: "f-view pre-wrap",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.gameExperience)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "type": "textarea",
      "maxlength": 1000,
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "请填写相关游戏经验",
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.gameExperience),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gameExperience", $$v)
      },
      expression: "ruleForm.gameExperience"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "沟通记录:",
      "prop": "contactResult"
    }
  }, [_c('p', {
    staticClass: "f-view pre-wrap",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.contactResult)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "type": "textarea",
      "maxlength": 1000,
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "请填写候选人沟通记录",
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.contactResult),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contactResult", $$v)
      },
      expression: "ruleForm.contactResult"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简历备注:",
      "prop": "remark"
    }
  }, [_c('p', {
    staticClass: "f-view pre-wrap",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.remark || '无')
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "type": "textarea",
      "maxlength": 1000,
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "请填写简历备注",
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remark", $$v)
      },
      expression: "ruleForm.remark"
    }
  })], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243d9f8a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/personal.vue
// module id = null
// module chunks = 